import languages from "../../../../data/languages";

export const STATION_LANGUAGE_TEMPLATE = {
  destinationAddress: "",
  destinationName: "",
};

// eslint-disable-next-line import/prefer-default-export
export const INITIAL_STATION_STATE = {
  qr: "",
  country: "",
  discount: 0,
  facebookUrl: "",
  instagramUrl: "",
  websiteUrl: "",
  linkedinUrl: "",
  location: {
    latitude: 0,
    longitude: 0
  },
  translations: Object.keys(languages) // +
    .map(langKey => ({
      ...STATION_LANGUAGE_TEMPLATE,
      language: langKey
    })),
  workingHours: "",
  owners: [],
};



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/initialStationState.js